import angular from 'angular';

import DatePickerComponent from './date-picker.cmpt';

export default angular
    .module('application.component.date-picker', [])
    .component(DatePickerComponent.selector, DatePickerComponent);



// WEBPACK FOOTER //
// ./src/application/component/date-picker/index.js